<template>
    <ui-modal id="update-status" title="Alterar Status" title-text="Selecione o novo status do chamado." size="xs">
        <form v-on:submit.prevent="update">
            <div class="input-box input-select">
                <select v-model="form.status">
                    <option value="">Selecione</option>
                    <option value="new">Novo</option>
                    <option value="progress">Em andamento</option>
                    <option value="closed">Finalizado</option>
                </select>
                <label for="input-title">
                    <span>Status:</span>
                </label>
            </div>
            <div class="control">
                <button type="submit" :class="indicator">Enviar </button>
            </div>
        </form>
    </ui-modal>
    
</template>

<script>
    import { uiModal } from '@/components'
    import { tickets } from '@/services'
    import { textareaResize } from '@/directives'
    export default {
        components: { uiModal },
        directives: { textareaResize },
        data() {
            return {
                users: [],
                form: {
                    status: null,
                },
            }
        },
        props: {
            ticket: {}
        },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        watch:{
            ticket: function(ticket){
                this.form.status = this.ticket.status
                return ticket
            }
        },
        methods: {
            update(){
                tickets.setStatus(this.ticket.id, this.form).then( response => {
                    response.data.row.index = this.ticket.index
                    this.$root.$emit('update-item-status', response.data.row);
                })
            }
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
